import React, { useContext, useState } from "react";
import { Badge, Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import { useHistory } from "react-router-dom";
import VolumeIndicator from "./VolumeIndicator";

const CallComponent = ({ callData, acceptCall, rejectCall, endCall, muteCall, getActiveCall, acceptIncomingCall, holdCall, answerIncomingCall, showKeypad, setShowKeypad }) => {
  // const { callState, callOnHook, error } = useTwilioCall(callData.call);
  const history = useHistory();
  const [switchCallPopup, setSwitchCallPopup] = useState({visible: false, activeCall: null})

  const answerCallClicked = async () => {

    const activeCallData = getActiveCall();

    if (activeCallData) {
      setSwitchCallPopup({ visible: true, activeCall: activeCallData.call })
    }else{
      answerIncomingCall(callData)
    }
   
  }

  const putActiveOnHoldAndAnswerCall = () => {
    holdCall(switchCallPopup.activeCall, true);
    //putallActiveCallsOnHold()

    answerIncomingCall(callData);
  }


  const putCallOnHold = async () => {
    if (callData.callStatus == "OnHold") {
      //reroute back to report when take off hold
      const id = callData.elevatorReportID
      if (id && !history.location.pathname.includes(`call/${id}`)) {
        history.push(`call/${id}`)
      }

      holdCall(callData.call, false)

    } else {
      holdCall(callData.call, true)
    }

  }



  return (
    <>

      {/* {error && <p>Error: {error}</p>} */}

      <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          {callData?.elevatorName &&
            <div title={callData.elevatorName} style={{ maxWidth: 150, display: "-webkit-box", WebkitBoxOrient: "vertical", WebkitLineClamp: 1, overflow: "hidden", fontSize: 12, fontWeight: "bold" }}>
              {callData.elevatorName}
            </div>
          }
          <div style={{ paddingRight: 10, fontWeight: "bold" }}>
            {callData.call.parameters?.From ? callData.call.parameters?.From : callData.call.customParameters?.get("To")}
          </div>

          {callData?.elevatorCompanyName ?
            <div title={callData.elevatorCompanyName} style={{ maxWidth: 150, display: "-webkit-box", WebkitBoxOrient: "vertical", WebkitLineClamp: 1, overflow: "hidden", fontSize: 12 }}>
              {callData.elevatorCompanyName}
            </div>
            :
            callData?.did &&
            <div title={callData.did} style={{ maxWidth: 150, display: "-webkit-box", WebkitBoxOrient: "vertical", WebkitLineClamp: 1, overflow: "hidden", fontSize: 12 }}>
              {callData.callStatus == "Incoming" || callData.callStatus == "Outgoing" ? "From: " : ""}{callData?.did}
            </div>
          }          

          {callData?.callType && (
            <div style={{ marginTop: 3, marginBottom: 3 }}>
              <Badge color={callData.callType === "Emergency" ? "danger" : "info"} style={{ fontSize: 9, lineHeight: 1, padding: "4px 7px" }}>
                {callData.callType === "CustomerService" ? "Service" : callData.callType}
              </Badge>
            </div>
          )}
        </div>

        <div>
        {callData.callStatus == "Incoming" && (<>
            <Button color="success" className="btn-fab btn-icon btn-round" onClick={() => answerCallClicked()} style={{ marginRight: 5 }} >
            <i className="las la-phone-volume" style={{ fontSize: 25 }}></i>
          </Button>
          <Button color="danger" className="btn-fab btn-icon btn-round" onClick={() => rejectCall(callData.call, callData.callLogID)} >
            <i className="las la-phone-volume" style={{ fontSize: 25 }}></i>
          </Button>  </>
        )}
        </div>

        {(callData.callStatus == "Active" || callData.callStatus == "OnHold" || callData.callStatus == "Muted") && (

          <>            
            <Button className="btn-fab btn-icon btn-round" onClick={() => { setShowKeypad(callData.call?.parameters?.CallSid, callData.call.parameters?.From ? callData.call.parameters?.From : callData.call.customParameters?.get("To")) }} style={{ backgroundColor: showKeypad ? "#464747" : "#929292", marginRight: 5 }} >
              <i className="las la-table" style={{ fontSize: 25 }}></i>
            </Button>

            {callData.callStatus != "OnHold" &&
              <Button color={"info"} className="btn-fab btn-icon btn-round" onClick={() => muteCall(callData.call, callData.callStatus == "Muted" ? false : true)} style={{ marginRight: 5 }}>
                <i className={callData.callStatus == "Muted" ? "las la-microphone-slash" : "las la-microphone"} style={{ fontSize: 25 }}></i>
            </Button>
            }
            <Button color={"success"} className="btn-fab btn-icon btn-round" onClick={() => putCallOnHold()} style={{ marginRight: 5 }}>
              <i className={callData.callStatus == "OnHold" ? "las la-play" : "las la-pause"} style={{ fontSize: 25 }}></i>
            </Button>

            <Button color="danger" className="btn-fab btn-icon btn-round" onClick={() => endCall(callData.call, callData.callLogID)} >
              <i className="las la-phone-volume" style={{ fontSize: 25 }}></i>
            </Button>

        </>
        )}

        {callData.callStatus === "Outgoing" && <p>Dialing...</p>}
      </div>

      <VolumeIndicator
        call={callData.call}
        isActive={callData.callStatus === "Active" || callData.callStatus === "Muted"}
      />


        <Modal isOpen={switchCallPopup.visible} centered={true} >
                <ModalBody style={{ justifyContent: "center", alignContent: "center", textAlign: "center" }} >
                    <i className="las la-phone" style={{ fontSize: 40 }}></i>
          <p style={{ fontSize: 16 }}>{`Do you want to answer this call and put ${switchCallPopup?.activeCall?.parameters?.From ? switchCallPopup?.activeCall?.parameters?.From : switchCallPopup?.activeCall?.customParameters?.get("To")} on hold?`}</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => { setSwitchCallPopup({ visible: false, activeCall: null }) }} style={{ margin: "auto", display: "block" }} >Cancel</Button>
                    <Button color="primary" onClick={() => {putActiveOnHoldAndAnswerCall(); setSwitchCallPopup({ visible: false, activeCall: null }) }} style={{ margin: "auto", display: "block" }} >Answer Call</Button>
                </ModalFooter>
      </Modal>

    </>
  );
};

export default CallComponent;
